import React from 'react'
import './index.scss'

import useWindowSize from "@rooks/use-window-size";
import ParticleImage, {
  // ParticleOptions,
  Vector,
  forces,
  // ParticleForce
} from "react-particle-image";
import { Row, Col } from 'antd'

import Logo from '../../assets/images/logo-dots.png'

const Home = props => {
  const particleOptions = {
    filter: ({ x, y, image }) => {
      // Get pixel
      const pixel = image.get(x, y);
      // Make a particle for this pixel if blue > 50 (range 0-255)
      return pixel.b > 50;
    },
    color: ({ x, y, image }) => "#",
    radius: () => Math.random() * 1.5 + 0.5,
    mass: () => 40,
    friction: () => 0.15,
    initialPosition: ({ canvasDimensions }) => {
      return new Vector(canvasDimensions.width / 2, canvasDimensions.height / 2);
    }
  };

  const motionForce = (x, y) => {
    return forces.disturbance(x, y, 5);
  };

  const { innerWidth, innerHeight } = useWindowSize();

  return (
    <div className='homePage'>
      <div className='content'>
        <Row>
          <Col md={14}>
            <div className='contentLeft'>
              <h1>Futures ecosystem and automated basis <span>Trade Aggregator. </span></h1>
            </div>

          </Col>
          <Col md={10}>
            <ParticleImage
              src={Logo}
              width={Number(innerWidth)}
              height={Number(innerHeight)}
              scale={0.5}
              entropy={200}
              maxParticles={1000}
              particleOptions={particleOptions}
              mouseMoveForce={motionForce}
              touchMoveForce={motionForce}
              backgroundColor="#fff"
            />
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default Home